// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__2U0to","header":"MergedInvoice_header__3OkzF"};